// The "needs you" badge count, shared by every nav control that renders it.
//
// Open conflicts from the (cached) briefing payload — the only "needs you" rail with a backend
// today. Tasks/paused lanes join the count when their rails exist. Session-local outcomes
// (resolved/snoozed just now) drop out immediately, without waiting for a brief regen.
//
// Lives in its own hook because the badge renders in BOTH the desktop pill row and the mobile tab
// bar; two copies of this expression would drift the moment either count changes.

import { useTeamTodaySurface } from './useTeamTodaySurface';
import { useConflictOutcomes, outcomeClears } from '../lib/conflict-local';

export function useNeedsYouCount(): number {
  const { data: today } = useTeamTodaySurface();
  const outcomes = useConflictOutcomes();
  return (
    today?.data?.tasks?.filter(
      (t) => t.stream === 'conflict' && !outcomeClears(outcomes.get(t.briefingItemId ?? ''))
    ).length ?? 0
  );
}
